import React, { useState } from 'react';

import { ReactComponent as ArrowDownIcon } from '../../../Shared/svgs/arrow-triangle-down-magenta.svg';
import { ReactComponent as ArrowRightIcon } from '../../../Shared/svgs/arrow-triangle-right-magenta.svg';
import { ReactComponent as ApartmentsHouseIcon } from '../../../Shared/svgs/apartments-house-magenta.svg';

export default function Sites({ sites }) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(prevState => !prevState);
    };

    return (
        <div className="generic-details__block sites-list">
            <div className="sites-header" onClick={toggleDropdown}>
                <h3>Sites</h3>
                {isOpen ? (
                    <ArrowDownIcon className="arrow-icon" />
                ) : (
                    <ArrowRightIcon className="arrow-icon" />
                )}
            </div>
            {isOpen && (
                <ul className="generic-site-list">
                    {sites.map((site, index) => (
                        <li key={index} className="site-item">
                            <ApartmentsHouseIcon className="apartments-icon" />
                            {site}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}